import { isEmailAddressValid,doesStringHaveSpecialChars, isNumeric } from "../../util/Validators";

export const validateInput = (name, value) => {
    let hasError = false,
        error = ""
    switch (name) {
        case "userId":
            if (value.trim() === "") {
                hasError = true
                error = "User ID cannot be empty"
            } else if (doesStringHaveSpecialChars(value)) {
                hasError = true
                error = "Invalid User ID. Avoid Special characters"
            } else if (value.length < 7) {
                hasError = true
                error = "userId must be greater than 7 characters"
            }
            else {
                hasError = false
                error = ""
            }
            break
        case "verificationCode":
            if (value.trim() === "") {
                hasError = true
                error = "Verification code cannot be empty"
            } else if (!isNumeric(value)) {
                hasError = true
                error = "Invalid Verification Code."
            } else {
                hasError = false
                error = ""
            }
            break
        case "email":
            if (value.trim() === "") {
                hasError = true
                error = "Email cannot be empty"
            } else if (!isEmailAddressValid(value)) {
                hasError = true
                error = "Invalid Email"
            } else {
                hasError = false
                error = ""
            }
            break
        default:
            break
    }
    return { hasError, error }
}